import axios from 'axios';
import { API_BASE_URL } from '../constants';

export default class OtherAssetsRiskAssessmentService {
	static instance;

	static getInstance() {
		if (!OtherAssetsRiskAssessmentService.instance) {
			OtherAssetsRiskAssessmentService.instance = new OtherAssetsRiskAssessmentService();
		}

		return OtherAssetsRiskAssessmentService.instance;
	}

    async fetchRisks(assetId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/other_asset/${assetId}/risks`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data.data
    }

    async fetchMatrix(assetId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/other_asset/${assetId}/risk_rate/matrix`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data.data
    }
}